<template>
 <div style="padding:12px 0">
	 <div style="float:left;width:100%;">
		 <div style="line-height:75px;">
			 <el-input class="searchInput" @keyup.enter.native="Search" v-model="val" placeholder="文章标题、作者、关键词、摘要" size="small" ></el-input>
	 	 	<el-button type="warning"  @click="Search" size="medium">检索</el-button>
			  <el-button type="warning" class="gjsss" plain @click="AdvancedSearch" href="javascript:void(0);" size="medium">高级检索</el-button>
		 </div>
		 <div class="issn_p">
			 <p>★ 国际丝绸联盟会刊 &nbsp;&nbsp; ★ 中国丝绸协会会刊</p>
		 </div>
	 </div>
	     
	 <div class="clearfix"></div>

	
 </div>
</template>
<script>
export default {
  name: 'search',
  data () {
    return {
		val:"",
		dlistnumpre:''
    }
  },
  methods:{
	  //简单搜索
	  Search(){
		  if(this.val ==""){
			  alert('请填写检索内容')
		  }else{
			  this.$newOpen("/#/QuickSearch?isdatab=true")
			  localStorage.setItem("value",this.val)
			  }
	  },
	  //高级搜索
	  AdvancedSearch(){
		  	this.$router.push("/AdvancedSearch?isdatab=true")
	  },
	  Downloadrank(){
		  	this.$router.push("/DownloadlistViewlist?Key=ReadRank")
	  },
	  Viewrank(){
		  	this.$router.push("/DownloadlistViewlist?Key=ViewRank")
	  },
	  QuickSearch(){
		  	this.$router.push("/QuickSearch")
	  },
	  Dlistnum(){
		  	this.$router.push("/Dlistnum")
	  },
	  
  }
}
</script>
<style>
.searchInput{ width: 66% !important; margin-right: 8px;}
.el-input__inner{height: 36px !important;line-height: 36px !important;}
 .el-button--warning.is-plain{background: none !important;border: none;}
.search .el-button--warning{color: #7a5c03; background: #f5c73e;}
.search .el-button--medium{padding: 10px;border-radius: 0;border: none;}
.search_button .el-button{ width: 48%; margin-right: 1%;}
.search_button .el-button:last-child{ margin-right: 0;}
.el-input__inner{ border: 1px #cecece solid !important;}
.searchInput .el-input__inner{border-radius: 0 !important;}
.search_menu li{ float: left; width: 33%; text-align: center; line-height: 20px !important; }
.search_menu li a{ color: #333 !important;}
.gjsss{margin: 0 !important;}
.issn_p p{height: 18px;line-height: 18px;font-weight: 600;color: #f5c73e;}
</style>
